import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_RET001_Request,
  IAPI_RET001_Response,
  IAPI_RET007_Request as UpdateRequest,
  IAPI_RET007_Response as UpdateResponse,
} from "../../../type/apiType";
//退職金支払参照API
//API仕様書_退職者
const httpAPI_RET001 = async (
  param: IAPI_RET001_Request
): Promise<IAPI_RET001_Response> => {
  let res = await http.post(ApiUrl.API_RET001, {
    ...param,
  });
  return res.data;
};

// 「被共済職員退職届、退職手当金請求書、合算制度利用申出書」の取り下げ更新
// API仕様書_退職者
const httpAPI_RET007 = async (
  param: UpdateRequest
): Promise<UpdateResponse> => {
  let res = await http.post(ApiUrl.API_RET007, {
    ...param,
  });
  return res.data;
};
export { httpAPI_RET001, httpAPI_RET007 };
